if ('undefined' !== typeof module) {

    module.exports = function initDataTable(){


        $('#datatables').DataTable({
            "pagingType": "full_numbers",
            "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
            responsive: true,
            language: {
              search: "_INPUT_",
              searchPlaceholder: "Buscar elementos",
              info: "Mostrando _START_ a _END_ de _TOTAL_ elementos",
              infoEmpty: "No hay elementos en la lista",
              infoFiltered: "(filtrado de _MAX_ elementos)",
              lengthMenu: "Mostrando _MENU_ elementos",
              zeroRecords: "No hay elementos encontrados",
              paginate: {
                first: "Primero",
                previous: "Previo",
                next: "Siguiente",
                last: "Último"
              }
            }

        });


        var table = $('#datatables').DataTable();

        // Edit record
        table.on( 'click', '.edit', function () {
            $tr = $(this).closest('tr');

            var data = table.row($tr).data();
            alert( 'You press on Row: ' + data[0] + ' ' + data[1] + ' ' + data[2] + '\'s row.' );
        } );

        // Delete a record
        table.on( 'click', '.remove', function (e) {
            $tr = $(this).closest('tr');
            table.row($tr).remove().draw();
            e.preventDefault();
        } );

        //Like record
        table.on( 'click', '.like', function () {
            alert('You clicked on Like button');
        });

        //  Activate the tooltips
        // $('[rel="tooltip"]').tooltip();
    }
}



// WEBPACK FOOTER //
// src/assets/js/init/initDataTable.js